import { Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';

// Pages
import { HomePage } from './pages/HomePage';
import { DashboardPage } from './pages/DashboardPage';
import { ProjectPage, CreateProjectPage, NotFoundPage } from './pages/ProjectPage';
import { ProjectViewPage } from './pages/ProjectViewPage';

function App() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
      <Navbar />
      
      <main className="pt-16"> {/* Padding pour compenser la navbar fixe */}
        <Routes>
          {/* Routes principales */}
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/project/new" element={<CreateProjectPage />} />
          <Route path="/project/:projectId" element={<ProjectViewPage />} />

          {/* Route 404 */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
